import React from "react";

const Emoji = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M18 2c8.837 0 16 7.163 16 16s-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2zm0 3.2a12.8 12.8 0 100 25.6 12.8 12.8 0 000-25.6zm8 14.4a8 8 0 01-16 0h16z"
              fill={fill}
        />
        <circle className="u_fill" cx={12.773} cy={13.815} r={2.24} fill={fill} />
        <circle className="u_fill" cx={23.227} cy={13.815} r={2.24} fill={fill} />
    </svg>
);

export default Emoji;
